export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pyodide.worker.6d06c088.js");
}
